import { getDashboardDataList, listQuickLink } from "../../services/workspace/dashboard.service";
import {
    exportByModule,
    getFormByModule,
    getLogsList,
    ImportByModule,
    ImportByUser,
} from "../../services/workspace/global.service";
import {
    _setQuickLinks,
    _setShowUpload,
    _setUploadFiles,
    _updateUploadFiles,
} from "../slices/global.slice";

export const _fetchFormFields = (module, callback = () => null, parms = {}) => async (dispatch) => {
    try {
        const response = await getFormByModule(module, parms);
        if (response) {
            callback(false, response);
        }
    } catch (error) {
        callback(true, error);
        console.error(
            "An error occurred while fetching the form fields data:",
            error
        );
    }
};

export const _ImportByModule =
    (module = "", payload = [], fileData = null, callback = () => null) =>
        async (dispatch) => {
            const _fileData = fileData;
         
            try {
                // dispatch(_setUploadFiles({ ..._fileData }));
                let response = null;
                if(module === "staff") {
                    response = await ImportByUser(payload); 
                }else{
                    response = await ImportByModule(module, payload);
                }

                 
                if (response) {
                    callback(false, response);
                    dispatch(
                        _updateUploadFiles({
                            ..._fileData,
                            loading: false,
                            failed: false,
                            success: true,
                        })
                    );
                }
            } catch (error) {
                callback(true, error);
                dispatch(
                    _updateUploadFiles({
                        ..._fileData,
                        loading: false,
                        success: false,
                        failed: true,
                    })
                );
                console.error(
                    "An error occurred while fetching the form fields data:",
                    error
                );
            }
        };

export const _fetchQuickLinks = (callback = () => null) => async (dispatch) => {
    try {
        const response = await listQuickLink();
        if (response) {
            callback(false, response);
            dispatch(_setQuickLinks(response && response.length ? [...response] : []));
        }
    } catch (error) {
        callback(true, error);
        console.error(
            "An error occurred while fetching the form fields data:",
            error
        );
    }
};

export const _fetchDashboardDataList = (callback = () => null) => async (dispatch) => {
    try {
        const response = await getDashboardDataList();
        if (response) {
            callback(false, response);
        }
    } catch (error) {
        callback(true, error);
        console.error(
            "An error occurred while fetching the dashboard list data:",
            error
        );
    }
};

export const _fetchAuditLogs = (callback = () => null) => async (dispatch) => {
    try {
        const response = await getLogsList();
        if (response) {
            callback(false, response);
        }
    } catch (error) {
        callback(true, error);
        console.error(
            "An error occurred while fetching the logs:",
            error
        );
    }
};

export const _exportByModule = (module, callback = () => null) => async (dispatch) => {
    try {
        const response = await exportByModule(module);
        if (response) {
            callback(false, response);
        }
    } catch (error) {
        callback(true, error);
        console.error(
            "An error occurred while fetching the form fields data:",
            error
        );
    }
};
